var map = {
	"./addtoprofilebutton_de.png": 54,
	"./addtoprofilebutton_en.png": 55,
	"./addtoprofilebutton_fr.png": 56,
	"./award_land_der_ideen.jpg": 57,
	"./cc.png": 58,
	"./certificate_sample.jpg": 59,
	"./clear.png": 60,
	"./companies.jpg": 61,
	"./course-cover-default.jpg": 62,
	"./course-placeholder.jpg": 63,
	"./course_default.png": 64,
	"./download-easy-guide.jpg": 65,
	"./drag_dark.png": 66,
	"./drag_light.png": 67,
	"./draggable.png": 68,
	"./example_voucher_card_de.jpg": 69,
	"./example_voucher_card_en.jpg": 70,
	"./example_voucher_card_fr.jpg": 71,
	"./fabian.jpg": 72,
	"./female_speaker_bg.jpg": 73,
	"./h5p_docu_1.png": 74,
	"./h5p_docu_2.png": 75,
	"./logo-iversity-without-padding.png": 76,
	"./logo-iversity.png": 77,
	"./logo_highres.png": 78,
	"./logo_iversity_springer.svg": 79,
	"./organisation_purchase.jpg": 80,
	"./petal_cutted.png": 81,
	"./posters_points.png": 82,
	"./professor_bg.jpg": 83,
	"./purchase_voucher_header.jpg": 84,
	"./referrals.jpg": 85,
	"./speech-bubble.svg": 86,
	"./voucher_card.png": 87,
	"./work_with_us.png": 88
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53;